const StatusEnum = {
  NoSelection: 'noselection',
  Confirmed: 'confirmed',
  Unconfirmed: 'unconfirmed',
  NoFit: 'nofit',
};

export default StatusEnum;
